import React from "react";
import { OutboundLink } from "./OutboundLink";
import { SocialShareButtons } from "./SocialShareButtons";

type Author = {
  name: string;
  url: string;
};

const getDatePublished = () => {
  const timestamp = process.env.REACT_APP_PUB_DATE;
  if (!timestamp) {
    throw new Error("No publication date defined in .env file!");
  } else {
    const date = new Date(timestamp.replace(/-/g, "/"));
    const dateFormatted = date.toLocaleDateString("en-us", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
    return dateFormatted;
  }
};

const generateAuthorByline = (byline: Author[]) => (
  <>
    {byline.map((author, i) => (
      <span key={i} className="author">
        {/* <OutboundLink to={author.url}>{author.name}</OutboundLink> */}
        {i === 0 ? (
          <OutboundLink to={author.url}>{author.name}</OutboundLink>
        ) : i < byline.length - 1 ? (
          <>
            {", "}
            <OutboundLink to={author.url}>{author.name}</OutboundLink>
          </>
        ) : i < byline.length ? (
          <>
            {" and "}
            <OutboundLink to={author.url}>{author.name}</OutboundLink>
          </>
        ) : (
          ""
        )}
      </span>
    ))}
  </>
);

export const TopAttribution = () => {
  const byline = JSON.parse(process.env.REACT_APP_AUTHOR as string) as Author[];
  return (
    <div className="eyebrow mt-6 mb-6">
      <p className="has-text-weight-light">By {generateAuthorByline(byline)}</p>
      <p className="has-text-weight-semibold has-text-left  my-2">
        {getDatePublished()}
      </p>
      <SocialShareButtons />
    </div>
  );
};

export const FooterAttribution = () => {
  const additionalReporters = [
    {
      name: "Kennedy Sessions",
      url: "https://www.thecityreporter.nyc/author/kennedy-sessions/",
    },
    {
      name: "Lilly Sabella",
      url: "https://www.thecityreporter.nyc/author/lilly-sabella/",
    },
  ];
  const editors = [
    {
      name: "Richard Kim",
      url: "https://www.thecityreporter.nyc/author/richard-kim/",
    },
  ];
  const design = [
    {
      name: "Sam Rabiyah",
      url: "https://www.samrabiyah.com/",
    },
  ];
  const photo = [
    {
      name: "Ben Fractenberg",
      url: "https://www.thecityreporter.nyc/author/ben-fractenberg/",
    },
    {
      name: "Alex Krales",
      url: "https://www.thecityreporter.nyc/author/akrales/",
    },
    {
      name: "Gwynne Hogan",
      url: "https://www.thecityreporter.nyc/author/gwynne-hogan/",
    },
  ];
  const additionalDesign = [
    {
      name: "Sarah Almukhtar",
      url: "https://sarahalmukhtar.github.io/",
    },
  ];
  return (
    <>
      Additional reporting by {generateAuthorByline(additionalReporters)}.
      Edited by {generateAuthorByline(editors)}. Design and development by{" "}
      {generateAuthorByline(design)}. Photography by{" "}
      {generateAuthorByline(photo)}. Additional design support from{" "}
      {generateAuthorByline(additionalDesign)}.
    </>
  );
};
